import React from 'react';
import { IProps } from '../../domain/model';
import { MailSendSettingForm } from '../../components/admin/mailSendSetting/mailSendSetting';

/**
 * メール送信設定画面
 * @param state State
 * @returns 画面
 */
export default function MailSendSettingPage({ state }: IProps): JSX.Element {
  return (
    <>
      {!state.loading && (
        <>
          <MailSendSettingForm />
        </>
      )}
    </>
  );
}
